<template>
  <div>
    <div class="d-flex align-center">
      <slot name="title" v-bind="{ showDialog }">
        <a v-if="isEdit" @click="showDialog" href="#" v-b-tooltip.hover :title="'Edit location'">
          {{ item.locationNames[0] }}
        </a>
        <a
          class="btn btn-primary mr-2 p-2"
          v-else-if="item._id"
          @click="showDialog"
          v-b-tooltip.hover
          :title="'Edit location'"
        >
          <i class="far fa-edit fa-fw text-white"></i>
        </a>
        <b-btn :disabled="disabled" v-else variant="primary" @click="showDialog">Map</b-btn>
      </slot>
    </div>
    <b-modal
      scrollable
      ref="container"
      size="md"
      :title="`${item._id ? 'Edit' : 'Add'} location`"
      @hidden="cancel"
      hide-footer
      modal-class="modal right fade"
      dialog-class="modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-md p-0"
      content-class="no-max-height p-0"
      body-class="p-0"
    >
      <loading v-if="loading"></loading>
      <FormInput
        :key="tempItem.updatedAt"
        :item="tempItem"
        @submit="submit"
        @cancel="cancel"
        :supplier="supplier"
        :pending="pending"
        :error="error"
        v-else-if="show"
      />
    </b-modal>
  </div>
</template>
<script>
import { options } from './types';

export default {
  name: 'FormModal',
  components: {
    FormInput: () => import('./FormInput')
  },
  props: {
    isEdit: Boolean,
    disabled: Boolean,
    item: Object,
    noSave: Boolean,
    supplier: Object
  },
  data() {
    const tempItem = this.rawData(JSON.parse(JSON.stringify(this.item || {})));

    tempItem.mappings.forEach((map) => {
      map.groups = options.filter((e) => map.groups.includes(e.classType));
    });
    return {
      error: false,
      loading: false,
      pending: false,
      tempItem,
      show: false
    };
  },
  methods: {
    async onRemove() {
      this.remove && (await this.remove());
      this.cancel();
    },
    rawData(tempItem = {}) {
      if (!tempItem.mappings) tempItem.mappings = [];
      if (!tempItem.locationNames) tempItem.locationNames = [];
      return tempItem;
    },
    async showDialog() {
      this.$refs.container.show();
      this.show = true;
    },
    async submit(model) {
      try {
        this.pending = true;
        this.error = false;
        if (model._id) {
          await this.$http.put(`/suppliers/${this.supplier._id}/locations-image-mapping/${this.tempItem._id}`, model);
          Object.assign(this.item, model);
        } else {
          const { data } = await this.$http.post(`/suppliers/${this.supplier._id}/locations-image-mapping`, model);
          if (!this.noSave) Object.assign(this.item, data);
        }

        this.$emit('change', this.item);
        this.cancel();
      } catch (e) {
        this.error = e.data || e;
      } finally {
        this.pending = false;
      }
    },
    cancel() {
      this.$refs.container.hide();
      this.tempItem = this.rawData(JSON.parse(JSON.stringify(this.item || {})));
      this.tempItem.mappings.forEach((map) => {
        map.groups = options.filter((e) => map.groups.includes(e.classType));
      });
      this.show = false;
    }
  }
};
</script>
